import React, { useEffect,useState } from 'react';
import { connect } from 'react-redux';

import { fetchDoctors, fetchPatients, fetchAnalytics, fetchAnalyticsforadmin } from '../Actions';

import AdminSideBar from './Adminsidebar';
import WeeklyRiskTrend from './graphs/WeeklyRiskTrend';
import RiskDistribution from './graphs/RiskDistribution';
import ClipLoader from "react-spinners/ClipLoader";

import doctorbox from '../Assets/images/admindashboard/doctorbox.svg';
import medicalfile from '../Assets/images/admindashboard/medicalfile.svg'
import assessmentsImg from '../Assets/images/dashboard/doctor.svg';
import virusImg from '../Assets/images/dashboard/virus.svg';
import axios from '../axios';
import AdminNavbar from './Adminsidebar';
import Topbar from './Topbar';

const AdminDashboard = (props) => {
  //used to ttigger and check api respone in index.js 166 line
var count = 0
var today = new Date();
var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
const [loading, setLoading] = useState(true);
const [yesterdayAssessments,setYesterdayAssessments] = useState(0);
  useEffect(() => {
    
    props.fetchDoctors().then(() => setLoading(false));
    props.fetchPatients('','').then(() => setLoading(false));
    // props.fetchAnalytics('2022-01-01','2020-01-01');
    // getAnalyticsForAdmin/{adminId}/{start_date}/{end_date}')
    // setPatientCount(props.analytics.patientsCount);
    props.fetchAnalyticsforadmin(date,'2019-01-01') ;
    
    getTotalCountApi();
    fetchYesterdayCountApi(); 
  }, []);

  const [total_patients, setTotal_patients] = useState();
  const [total_assessments, setTotal_assessments] = useState();
  const [total_doctors, setTotal_doctors] = useState();

  console.log("This is total count data");
  // ?userId=${props.match.params.clientId}
  

  const fetchYesterdayCountApi = async () => {
    try{
      const yesterday = new Date(); // Subtract one day (in milliseconds) from the current date
      yesterday.setDate(yesterday.getDate() - 1);
      const yesterdayDate = yesterday.toISOString().slice(0, 10);
      
        await axios.get(`getPatientsAssessments?created_on_start=${yesterdayDate} 00:00:00&created_on_end=${yesterdayDate} 23:59:59`,
        
        {
          headers: {accessToken: localStorage.accessToken},
       
        }
        )
        .then((response) => {
         
          console.log(response.data.data.assessment_count);
         setYesterdayAssessments(response.data.data.assessment_count);
         console.log(yesterdayAssessments);
    
      
        })
        .catch((error) =>{
          console.log("error", error);
        })
     
    }
    catch(e){
console.log(e);
    }
   
  }
  const getTotalCountApi = () => {
    axios
      .get(
        `/admin/total_count`,
        {
          headers: { accessToken: localStorage.accessToken },
        }
      )
      .then((response) => {
        console.log(response);
        // setRecords(response.data.data.doc_count);

        setTotal_doctors(response.data.data.doc_count);
        // console.log(response.data.data.doc_count);
        setTotal_assessments(response.data.data.total_assessments);
        setTotal_patients(response.data.data.patients_count);
        // setdateData(response.data.data.assessment_count);
      })
      .catch((error) => {
        console.log(error);
      });
  }
// console.log(props.patient.count)
  
// console.log(props)
const dataList = React.useMemo(
  () => props.doctors.doctors,
  [props.doctors.doctors]
);
dataList.filter(function (n) {
  
  if(n.role === "doctor"){
    count++;
  };
            })
const [width, setWidth] = React.useState(window.innerWidth);
  const breakpoint = 1000;
  React.useEffect(() => {
   const handleResizeWindow = () => setWidth(window.innerWidth);
    // subscribe to window resize event "onComponentDidMount"
    window.addEventListener("resize", handleResizeWindow);
    return () => {
      // unsubscribe "onComponentDestroy"
      window.removeEventListener("resize", handleResizeWindow);
    };
  }, []);

  if (width > breakpoint) {
    
    if(loading){
      return (
        <div className="loadingdiv">
        <ClipLoader color={"#fd8c00"} loading={loading} size={30} />
      </div>
      )
    }else
  return (
    <div className="dashboard">
      {/* <AdminNavbar admindashboard /> */}
      {/* <AdminSideBar admindashboard /> */}
      <div className="dashboard__content">
        <Topbar />
        {/* <div className="card2" style={{backgroundColor: "lightgreen"}} >doctorId: {props.analytics.records[0] ? props.analytics.records[0].docId : null}</div> */}
        <div className="dashboard__adminsummary">
          <div className="card2">
            <div className="card2--info__content">
              <p className="card2--info__title">Total</p>
              <img src={doctorbox} alt="patients" />
              {/* <p className="card2--info__count">
              Doctors -  {count}
              <br></br>
              DH Agents - {props.doctors.count - count}
              </p> */}
              <div style=
                {{display: "flex",
                'flex-direction': "row",
             }}
              >
                <div style=
                {{display: "flex",
                'flex-direction': "column"}}>
                  {/* <div className='card2--info__counttotal'>{total_doctors}</div> */}
                  <div className='card2--info__counttotal'>
                    {/* {count} */}
                    {total_doctors}
                  </div>

                  <div className="card2--info__descriptiontotal">Doctors</div>
                </div>
                <div style=
                {{display: "flex",
                'flex-direction': "column",
                'margin-inline-start': '2rem'}}>
                <div className='card2--info__counttotal'>{isNaN(props.doctors.count - count) ? 0  : props.doctors.count - count}</div>
                  <div className="card2--info__descriptiontotal">DH Executives</div>
                </div>
                
              </div>
            </div>
            <p
              className="card2--info__description"
              style={{ color: '#46360999' }}
            >
              
            {/* THis is the Total number of patients who have been scanned atleast once  */}
            </p>
          </div>
          
          <div className="card2 card2--total-patients">
            <div className="card2--info__content">
              <p className="card2--info__title">Total Patients</p>
              <img src={medicalfile} alt="high risk" />
              <p className="card2--info__count">
                {/* {props.analytics.highRiskCount} */}
                {/* {props.patient.count} */}
                {total_patients}
                
              </p>
            </div>
            <p
              className="card2--info__description"
              style={{ color: '#FFA500' }}
            >
              THis is the Total number of patients who have been scanned atleast once
            </p>
          </div>
          <div className="card2 card2--assessments">
            <div className="card2--info__content">
              <p className="card2--info__title">Assessments</p>
              <img src={assessmentsImg} alt="assessments" />
              <div style=
                {{display: "flex",
                'flex-direction': "row",
             }}
              >
                <div style=
                {{display: "flex",
                'flex-direction': "column"}}>
                  {/* <div className='card2--info__counttotal'>{total_doctors}</div> */}
                  <div className='card2--info__counttotal'>
                    {/* {count} */}
                    {total_assessments}
                  </div>

                  <div className="card2--info__descriptiontotal">Total</div>
                </div>
                <div style=
                {{display: "flex",
                'flex-direction': "column",
                'margin-inline-start': '2rem'}}>
                <div className='card2--info__counttotal'>{yesterdayAssessments}</div>
                  <div className="card2--info__descriptiontotal">Yesterday</div>
                </div>
                
              </div>
            </div>
            {/* <p
              className="card2--info__description"
              style={{ color: '#1ad94799' }}
            >
              Number of assessments divided by the total Number of patients
              scanned
            </p> */}
          </div>
          <div className="card2 card2--high-risk">
            <div className="card2--info__content">
              <p className="card2--info__title">Patients with Risk</p>
              <img src={virusImg} alt="high risk" />
              <p className="card2--info__count">
                {props.analytics.highRiskCount}
              </p>
            </div>
            <p
              className="card2--info__description"
              style={{ color: '#FFA500' }}
            >
              This is the Total number of patients who have been scanned atleast once
            </p>
          </div>
        </div>
        <div className="dashboard__analytics">
          <WeeklyRiskTrend />
          {/* <div className="dashboard__analytics__risk">
            <RiskDistribution />
          </div> */}
        </div>
      </div>
    </div>
  );
  }

  else {
    if(loading){
      return (
        <div className="loadingdiv">
        <ClipLoader color={"#fd8c00"} loading={loading} size={30} />
      </div>
      )
    }else
    return (
      <div className="dashboard">
        {/* <AdminNavbar admindashboard /> */}
        {/* <AdminSideBar admindashboard /> */}
        <div className="dashboard__content">
          <Topbar />
        {/* <div className="mobiletitle" style={{marginBottom:"1.5rem"}}>swaasa</div> */}
          {/* <div className="card2" style={{backgroundColor: "lightgreen"}} >doctorId: {props.analytics.records[0] ? props.analytics.records[0].docId : null}</div> */}
          <div className="dashboard__adminsummary">
            <div className="card2">
              <div className="card2--info__content">
                <p className="card2--info__title">Total Doctors</p>
                <img src={doctorbox} alt="patients" />
                <p className="card2--info__count">
                  {/* {props.doctors.count} */}
                  {total_doctors}
                </p>
              </div>
              <p
                className="card2--info__description"
                style={{ color: '#46360999' }}
              >
              THis is the Total number of patients who have been scanned atleast once
              </p>
            </div>
            <div className="card2 card2--total-patients">
              <div className="card2--info__content">
                <p className="card2--info__title">Total Patients</p>
                <img src={medicalfile} alt="high risk" />
                <p className="card2--info__count">
                {/* {props.patient.count} */}
                {total_patients}
                </p>
              </div>
              <p
                className="card2--info__description"
                style={{ color: '#FFA500' }}
              >
                THis is the Total number of patients who have been scanned atleast once
              </p>
            </div>
            <div className="card2 card2--assessments">
              <div className="card2--info__content">
                <p className="card2--info__title">Assessments</p>
                <img src={assessmentsImg} className='assesments_image' alt="assessments" />
                <p className="card2--info__count">
                {/* { props.patient.assessment_count} */}
                {total_assessments}
                </p>
                <p >
                {/* { props.patient.assessment_count} */}
                {yesterdayAssessments}
                </p>
              </div>
            
            </div>
            <div className="card2 card2--high-risk">
              <div className="card2--info__content">
                <p className="card2--info__title">Patients with Risk</p>
                <img src={virusImg} className='assesments_image' alt="high risk" />
                <p className="card2--info__count">
                  {props.analytics.highRiskCount}
                </p>
              </div>
              <p
                className="card2--info__description"
                style={{ color: '#FFA500' }}
              >
                THis is the Total number of patients who have been scanned atleast once
              </p>
            </div>
          </div>
          <div className="dashboard__analytics">
            <WeeklyRiskTrend />
            {/* <div className="dashboard__analytics__risk">
              <RiskDistribution />
            </div> */}
          </div>
        </div>
      </div>
    );
  }
};

const mapStateToProps = (state) => ({
  analytics: state.analytics,
  zipCodes: state.zipCodes.list,
  doctors: state.doctors,
  patient: state.patient,
});

export default connect(mapStateToProps, { fetchDoctors, fetchPatients,fetchAnalytics,fetchAnalyticsforadmin })(AdminDashboard);
